import {
    CategoryHeaderRow,
    CategoryItemRow,
    ContainedRow,
    ExpandableRow,
    FullRowContent,
    GroupHeaderRow,
    GroupWithContentRows,
    InputRow,
    SelectableRow,
    StandardRow,
} from './base-table.interface';

export const isGroupHeaderRow = <G, T, E = never>(
    obj: InputRow<T, G, E>
): obj is GroupHeaderRow<G, T> | GroupWithContentRows<G, T, E> =>
    typeof (obj as any).isGroupHeaderRow === 'boolean' &&
    (obj as any).isGroupHeaderRow &&
    Array.isArray((obj as any).containedRows);

/**
 * Checks if row is a groupHeaderRow of a spare part list.
 *
 * **Spare Part List groupHeaders doesn't contain a driveGroup!**
 * Besides that, the types are identical.
 *
 * @param obj groupHeaderRow of a spare part list
 * @returns true if it looks like a group header row but does not contain a driveGroup
 */

// TODO check with Nicolas for which special case the outcommented if-statement was intended
// -> the outcommented implementation completely removes CategoryHeaderRows and their contained
// rows are hidden

// export const isGroupHeaderRowWithoutDriveGroups = <G, T, E = never>(
//     obj: InputRow<T, G, E>
// ): obj is GroupHeaderRow<G, T> | GroupWithContentRows<G, T, E> =>
//     isGroupHeaderRow(obj) && (obj as any).rowData && ((obj as any).rowData as any).driveGroup === undefined;

export const isStandardRow = <T>(obj: InputRow<T, any, any>): obj is StandardRow<T> =>
    typeof (obj as any).isStandardRow === 'boolean' && (obj as any).isStandardRow;

export const isExpandableRow = <T, E>(obj: InputRow<T, any, E>): obj is ExpandableRow<T, E> =>
    typeof (obj as any).isExpandableRow === 'boolean' && (obj as any).isExpandableRow;

export const isFullRowContent = <T>(obj: InputRow<T, any, any>): obj is FullRowContent<T> =>
    typeof (obj as any).isFullRowContent === 'boolean' && (obj as any).isFullRowContent;

export const isSelectableRow = <T>(obj: InputRow<T, any, any>): obj is SelectableRow<T> =>
    typeof (obj as any).isSelectableRow === 'boolean' && (obj as any).isSelectableRow;

export const isContainedRow = <T>(obj: InputRow<T, any, any>): obj is ContainedRow<T> =>
    typeof (obj as any).isContainedRow === 'boolean' && (obj as any).isContainedRow;

export const isCategoryHeaderRow = <G, T, E = never>(
    obj: InputRow<T, G, E>
): obj is CategoryHeaderRow<G, T> =>
    typeof (obj as any).isCategoryHeaderRow === 'boolean' && (obj as any).isCategoryHeaderRow;

export const isCategoryItemRow = <T>(obj: InputRow<T, any, any>): obj is CategoryItemRow<T> =>
    typeof (obj as any).isCategoryItemRow === 'boolean' && (obj as any).isCategoryItemRow;

/**
 * Checks wheter the obj has a defined property `rowData`
 *
 * @param obj object that needs to be checked
 * @returns wheter the obj has a property rowData which is defined
 */
export const hasRowData = <G, T, E = never>(
    obj: InputRow<T, G, E>
): obj is InputRow<T, G, E> & { rowData: T } => !!(obj as any)?.rowData;
